import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UrlHelperService {
  private IS_INTER = environment.IS_INTER || false;

  getCidParam(cid: number, isFirst: boolean = true): string {
    if (!this.IS_INTER || !cid) {
      return '';
    }
    const separator = isFirst ? '?' : '&';
    return `${separator}cid=${cid}`;
  }

  buildUrl(baseUrl: string, cid: number, additionalParams: any = {}): string {
    const params = new URLSearchParams();
    if (this.IS_INTER && cid) {
      params.append('cid', cid.toString());
    }
    Object.keys(additionalParams).forEach(key => {
      params.append(key, additionalParams[key]);
    });
    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }
}
